import { render } from "./VUEComponenteGraficoSpostamenti.vue?vue&type=template&id=20da5d2f"
import script from "./VUEComponenteGraficoSpostamenti.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoSpostamenti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__